var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhConsumerSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 798.417,
    height: 769.344,
    viewBox: "0 0 798.417 769.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7.737,
    y1: 0.5,
    x2: -8.737,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5.181,
    y1: 1,
    x2: -5.181,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7740",
    "data-name": "Group 7740",
    transform: "translate(-25 -139.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7739",
    "data-name": "Group 7739",
    transform: "translate(464.3 139.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M216.272,552.553h-8.479l2.831-165.616h2.831Z",
    transform: "translate(-131.917 191.192)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M425.27,473.541l13.686-21.15a317.093,317.093,0,0,0-14.041-32.868l-8.849,7.149,7.007-10.829c-6.679-13.145-11.933-21.428-11.933-21.428s-27.444,43.25-36.618,89.049l17.563,27.142-19.439-15.7a128.32,128.32,0,0,0-1.066,16.087c0,54.237,17.714,98.2,39.564,98.2s39.564-43.973,39.564-98.2c0-16.813-3.8-34.4-9.059-50.678Z",
    transform: "translate(-333.85 0.318)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M333.231,552.553h-8.479l2.831-165.616h2.831Z",
    transform: "translate(-28.146 191.192)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M542.232,473.541l13.686-21.15a317.061,317.061,0,0,0-14.041-32.868l-8.849,7.149,7.007-10.829C533.357,402.7,528.1,394.415,528.1,394.415s-27.448,43.253-36.612,89.049L509.04,510.6,489.6,494.9a128.309,128.309,0,0,0-1.066,16.087c0,54.237,17.714,98.2,39.564,98.2s39.564-43.972,39.564-98.2c0-16.813-3.8-34.4-9.059-50.678Z",
    transform: "translate(-230.083 0.318)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 77.905,
    cy: 77.905,
    r: 77.905,
    transform: "translate(0 38.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M274.261,622.456H256.78l5.828-341.485h5.826Z",
    transform: "translate(-88.453 97.176)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M509.815,348.408l28.22-43.606a653.837,653.837,0,0,0-28.952-67.772l-18.248,14.737,14.449-22.33c-13.777-27.1-24.6-44.182-24.6-44.182s-56.594,89.183-75.5,183.609l36.2,55.966-40.089-32.379a264.506,264.506,0,0,0-2.2,33.17c0,111.832,36.524,202.489,81.578,202.489s81.578-90.657,81.578-202.489c0-34.669-7.843-70.939-18.663-104.492Z",
    transform: "translate(-309.44 -185.255)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7738",
    "data-name": "Group 7738",
    transform: "translate(25 158.182)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 399.208,
    cy: 46.481,
    rx: 399.208,
    ry: 46.481,
    transform: "translate(0 658.198)",
    fill: "#a47cea",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10458",
    "data-name": "Path 10458",
    d: "M957.758,613.59a16.156,16.156,0,0,1,2.038,4.086c17.465,20.518,26.8,39.667,9.981,40.193-15.637.45-34.394,28.413-38.892,35.476a15.158,15.158,0,0,0,.536,1.608s22.011-36.566,39.887-37.083S977.452,635.582,957.758,613.59Z",
    transform: "translate(-818.65 -92.855)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10459",
    "data-name": "Path 10459",
    d: "M937.177,630.867c0,4.594-.517,8.307-1.148,8.307s-1.148-3.723-1.148-8.307.641-2.431,1.282-2.431S937.177,626.235,937.177,630.867Z",
    transform: "translate(-779.523 -93.471)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10460",
    "data-name": "Path 10460",
    d: "M933.557,636.539c-4.029,2.2-7.541,3.522-7.847,2.967s2.718-2.794,6.7-4.986,2.44-.593,2.747,0S937.615,634.347,933.557,636.539Z",
    transform: "translate(-769.549 -93.707)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10463",
    "data-name": "Path 10463",
    d: "M718.978,161.062c2.708-4.421,6.756-8.469,6.125-13.484-7.426.852-14.47-.957-21.274-4.1s-13.12-7.244-19.484-11.254c-2.507-1.579-5.005-3.129-7.493-4.565-3.943-2.268-7.857-4.785-11.867-7-5.742-3.158-11.608-5.742-18.049-6.24-1.158-.086-2.335-.105-3.512-.086-7.943.163-16.173,2.287-23.159-1.273l-.431-.23c-3.952-2.172-6.842-5.876-10.24-8.862a45.658,45.658,0,0,0-7.933-5.512c-5.149-2.871-10.737-5.168-16.02-7.876a25.176,25.176,0,0,1-3.828-2.459l-.9-.718-.2-.172-.651-.555-.411-.364-.421-.383-.325-.306-.526-.5-.057-.057-.842-.833-.335-.335-.584-.593-.344-.354-1.761-1.809c-.689-.7-1.4-1.388-2.124-2.058h0l-.689-.612-.2-.172-.555-.469-.268-.22-.546-.421-.268-.211-.823-.593a5.8,5.8,0,0,0-.8-.459l1.723-4.364L564.75,69.45l-71,172.306,5.149,2.125,40.624-98.57.287.287a81.621,81.621,0,0,0,33.581,19.982h.076c7.072,2.134,14.986,3.646,20.939,7.656a20.1,20.1,0,0,1,5.407,5.177c1.4,1.991,2.373,4.259,3.876,6.173.277.354.584.7.89,1.024a33.237,33.237,0,0,0,5.742,4.546l.957.622a186.136,186.136,0,0,0,19.235,11.867,75.72,75.72,0,0,0,11.953,4.976c3,.957,6.086,1.656,9.082,2.6a35.284,35.284,0,0,1,5.857,2.354c5.072,2.651,8.967,6.8,12.651,11.235,3.225,3.885,6.287,7.991,9.828,11.532,2.211,2.211,5.589,4.287,8.278,3a4.611,4.611,0,0,0,.536-.316c-.077-.144-.153-.287-.22-.44-2.115-4.431.488-9.9,3.991-13.465.364-.364.737-.727,1.12-1.081s1.062-.957,1.617-1.435c3-2.574,6.182-4.967,8.259-8.288a27.188,27.188,0,0,0,3.177-9.005c.957-4.507,1.589-9.149,4.039-12.986,1.617-2.536,4-4.7,5.742-7.13a10.776,10.776,0,0,0,2.105-4.909c.392-3.12-1.053-6.163-1.6-9.264a11.479,11.479,0,0,1-.191-2.565,13.542,13.542,0,0,1,2.239-6.393Z",
    transform: "translate(-145.36 -69.45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 5.484,
    height: 183.235,
    transform: "matrix(0.925, 0.381, -0.381, 0.925, 420.156, 1.536)",
    fill: "#d6d8e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10464",
    "data-name": "Path 10464",
    d: "M665.467,191.074c-2.412,3.771-3.043,8.335-3.972,12.766a26.73,26.73,0,0,1-3.129,8.852c-2.048,3.263-5.177,5.627-8.115,8.154-.536.459-1.072.957-1.589,1.407a15.186,15.186,0,0,0-1.1,1.062c-3.445,3.493-6,8.871-3.924,13.235a4.584,4.584,0,0,0,.22.431,4.536,4.536,0,0,1-.526.306c-2.641,1.273-5.962-.775-8.134-2.948-3.483-3.483-6.5-7.522-9.666-11.34-3.617-4.364-7.455-8.441-12.441-11.053a34.691,34.691,0,0,0-5.742-2.316c-2.938-.957-5.981-1.636-8.929-2.565a74.453,74.453,0,0,1-11.761-4.89,183.006,183.006,0,0,1-18.91-11.666l-.9-.612a32.681,32.681,0,0,1-5.646-4.469c-.306-.325-.6-.66-.871-1-1.474-1.914-2.44-4.115-3.828-6.067a19.782,19.782,0,0,0-5.321-5.091c-5.857-3.895-13.628-5.388-20.585-7.484h-.077a80.252,80.252,0,0,1-33.016-19.647,5.329,5.329,0,0,1-1.655-2.431c-.3-1.349.431-2.68,1.129-3.828q1.225-2.086,2.383-4.211a188.205,188.205,0,0,0,9.445-19.848q.9-2.225,1.751-4.479,2.172-5.742,3.962-11.647c.392-1.311.775-2.613,1.139-3.933.067-.249.134-.517.211-.8,1.589-6.46,3.713-21.36,10.249-16.891a37.036,37.036,0,0,1,5.407,4.689c1.273,1.292,2.517,2.622,3.828,3.9a37.836,37.836,0,0,0,3.378,2.957,24.766,24.766,0,0,0,3.828,2.412c5.187,2.66,10.69,4.89,15.752,7.742a44.9,44.9,0,0,1,7.8,5.417c3.34,2.948,6.182,6.584,10.068,8.718l.431.22c6.871,3.5,14.958,1.407,22.767,1.244,1.158,0,2.316,0,3.455.086,6.335.488,12.135,3.034,17.743,6.134,3.943,2.182,7.79,4.651,11.666,6.881,2.45,1.407,4.9,2.928,7.369,4.488,6.268,3.943,12.6,8.087,19.14,11.063s13.618,4.871,20.92,4.029c.622,4.928-3.359,8.91-6.019,13.264a13.311,13.311,0,0,0-2.249,6.278,11.231,11.231,0,0,0,.191,2.517c.536,3.053,1.914,6.039,1.569,9.111A10.594,10.594,0,0,1,671.094,184C669.4,186.451,667.084,188.586,665.467,191.074Z",
    transform: "translate(-101.868 -69.785)",
    fill: "#e6e8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10465",
    "data-name": "Path 10465",
    d: "M665.972,89.623l-5.34,12.68L643.1,94.916c1.579-6.421,3.7-21.322,10.24-16.853C658.077,81.3,661.283,86.025,665.972,89.623Z",
    transform: "translate(-229.088 -69.785)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10466",
    "data-name": "Path 10466",
    d: "M626.508,114.924l-2.278,5.417L604,111.824l4.651-11.044a44.9,44.9,0,0,1,7.8,5.417C619.809,109.154,622.613,112.79,626.508,114.924Z",
    transform: "translate(-152.206 -70.798)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10467",
    "data-name": "Path 10467",
    d: "M584.061,123.32l-6.211,14.738-20.231-8.517,5.244-12.441c1.158,0,2.316,0,3.455.086C572.654,117.665,578.454,120.21,584.061,123.32Z",
    transform: "translate(-65.374 -71.5)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10468",
    "data-name": "Path 10468",
    d: "M541.874,146.5l-3.943,9.359L517.7,147.345l5.015-11.9C528.973,139.421,535.318,143.555,541.874,146.5Z",
    transform: "translate(15.016 -72.288)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 21.953,
    height: 21.953,
    transform: "translate(431.558 32.471) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 21.953,
    height: 21.953,
    transform: "translate(472.022 49.499) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    "data-name": "Rectangle 1439",
    width: 21.953,
    height: 21.953,
    transform: "translate(512.483 66.534) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10469",
    "data-name": "Path 10469",
    d: "M527.433,173.548l-5.062,12.02-20.231-8.517,8.517-20.231,18.834,7.924a13.313,13.313,0,0,0-2.249,6.278,11.237,11.237,0,0,0,.191,2.526Z",
    transform: "translate(42.29 -73.208)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10470",
    "data-name": "Path 10470",
    d: "M683.112,124.265,674.6,144.5l-17.015-7.158a188.208,188.208,0,0,0,9.446-19.848Z",
    transform: "translate(-260.086 -71.516)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 21.953,
    height: 21.953,
    transform: "translate(443.27 61.22) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 21.953,
    height: 21.953,
    transform: "translate(483.743 78.25) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 21.953,
    height: 21.953,
    transform: "translate(524.204 95.294) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10471",
    "data-name": "Path 10471",
    d: "M671.37,154.227l-6.1,14.479A80.251,80.251,0,0,1,645.33,159.5l5.809-13.8Z",
    transform: "translate(-236.62 -72.73)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10472",
    "data-name": "Path 10472",
    d: "M628.915,172.027,620.4,192.258l-7.378-3.11c-.306-.325-.6-.66-.871-1-1.474-1.914-2.44-4.115-3.828-6.067A19.781,19.781,0,0,0,603,176.984l5.665-13.474Z",
    transform: "translate(-153.656 -73.496)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 21.953,
    height: 21.953,
    transform: "translate(495.448 106.999) rotate(22.82)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10473",
    "data-name": "Path 10473",
    d: "M547.218,207.617l-7.771,18.47c-.536.459-1.072.957-1.589,1.407l-19.389-8.163,8.517-20.231Z",
    transform: "translate(8.935 -75.027)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10474",
    "data-name": "Path 10474",
    d: "M508.274,208.555l-3.474-1.464,8.517-20.231,4.565,1.914c-1.694,2.392-4.039,4.517-5.627,7.005C509.834,199.559,509.2,204.124,508.274,208.555Z",
    transform: "translate(51.353 -74.5)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10475",
    "data-name": "Path 10475",
    d: "M611.863,202.067,609.71,207.2a183.023,183.023,0,0,1-18.91-11.666l.833-1.981Z",
    transform: "translate(-124.929 -74.788)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10476",
    "data-name": "Path 10476",
    d: "M570.454,219.867l-3.751,8.91c-3.617-4.364-7.455-8.441-12.441-11.053a34.694,34.694,0,0,0-5.742-2.316l1.713-4.058Z",
    transform: "translate(-43.058 -75.553)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10477",
    "data-name": "Path 10477",
    d: "M984.782,250.611l-5.2,55.611s-6.134,11.589-13.216,15.312c-4.852,2.536-14.355,10.527-19.838,15.312l-1.206,1.053c.488,1.368.746,2.211.746,2.211s-18.881,37.074-30.681,42.634-3.78,52.366-4.249,74.147c-.325,15.216-5.493,23.638-11.158,27.81.2.306.4.622.593.957,8.383,13.943,11.761,44.414,8.2,58.376a8.609,8.609,0,0,1-.727,1.914c2.1,11.484,4.182,30.1-2.105,38.432-9.445,12.508-20.3,63.487-20.3,63.487s-7.082,35.686-12.269,41.706c-3.771,4.373-3.56,42.883-3.158,63.7a74.735,74.735,0,0,0,8.354-.67c22.48-3,2.526,10.613-6.01,15.982,3.828,2.45,10.824,4.306,23.925,2.555,17.982-2.392,8.8,5.838,0,11.972a35.026,35.026,0,0,1-19.36,6.173l-65.075,1.206a101.443,101.443,0,0,1-.66-18.853l-17.226.316s-2.058-14.939.153-24.394l-1.1-.172,8.5-66.271s.469-61.171-.957-64.874c-4.278-11.2-1.914-28.978.957-42.328a87.459,87.459,0,0,0,.7-33.7,100.94,100.94,0,0,1,7.177-59.888c.23-.5.45-.957.67-1.407-2.948.057-4.785.153-4.785.153,8.967-6.488-.957-66.271-9.914-78.779s-29.341-5.531-29.341-5.531a36.775,36.775,0,0,1-5.11-5.1h-1c-7.35.2-17.647.239-28.336-.488-20.3-1.388-15.58-15.312-15.58-15.312l8.02-54.7s20.3-45.878,25.963-32.442-10.383,34.758-10.383,34.758-7.082,36.145,0,41.246c4.479,3.225,11.9,1.187,16.747-.737,1.522-.6,2.794-1.2,3.637-1.617l1.11-.574h0c7.656-3.828,27.255-11.053,35.609-11.426,10.383-.459,30.212-6.948,30.212-6.948,1.6-5.5,6.173-8.833,10.9-10.852h0a101.431,101.431,0,0,0,.766-14.7,7.5,7.5,0,0,1-1.713-1.349,5.086,5.086,0,0,1-.9-.957c-1.445-2.144-.737-5.12-1.962-7.388-.22-.4,2.919-3.034,2.613-3.369-1.914-1.684-4.689-2.6-6.335-4.393a5.235,5.235,0,0,1-1.493-2.077c-1.292-3.445-1.359-4.594-.957-8.24.316-3.215-.66-5.742-.172-8.46h0c-1.8-1.627-2.651-3.57-.708-5.5,3.57-3.56,13.4-4.4,18.183-4.661,3.751-.211,7.589,0,11.168-1.1,4.172-1.3,7.56-4.278,11.35-6.431s8.709-3.445,12.441-1.215c2.871,1.713,4.785,5.321,8.144,5.541,2.775.182,5.512-2.172,8.115-1.215l-.134.306a3.656,3.656,0,0,1,.6.163A35.5,35.5,0,0,1,881.7,282.747a23.675,23.675,0,0,1,4.22,13.513,23.982,23.982,0,0,1-11.484,20.413h0a.2.2,0,0,1,0,.057h0l-.144,1.493a54.932,54.932,0,0,0,.44,12.173l.89,1.215a38.569,38.569,0,0,1,3.493,1.914A95.745,95.745,0,0,1,898,329.352C907.448,328.4,929.583,315,929.583,315a5.683,5.683,0,0,1,1.187.258l.67-.66a36.365,36.365,0,0,1,17.972-9.331s1.177-3.474,3.78-9.733c1.818-4.373,13.216-28.71,13.216-28.71s4.718-19.465,3.78-29.2,14.594-28.26,17-25.944S991.395,241.348,984.782,250.611ZM848.631,558.647l-.268.124c-.66.383-1.273,2.469-1.857,5.742h0c-2.029,11.58-3.57,38.1-4.546,59.065-.182,3.981-.344,7.761-.488,11.2,2.335-10.728,4.785-22.48,5-26.011C846.784,604.285,847.895,577.021,848.631,558.647Z",
    transform: "translate(-621.979 -75.559)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10478",
    "data-name": "Path 10478",
    d: "M877.165,764.964s.459,12.345,27.437,8.689-9.149,17.838-9.149,17.838l-72.731,1.369s-4.278-31.581,6.4-31.581C829.593,761.309,877.165,764.964,877.165,764.964Z",
    transform: "translate(-648.809 -99.207)",
    fill: "#4a4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10479",
    "data-name": "Path 10479",
    d: "M877.165,764.964s.459,12.345,27.437,8.689-9.149,17.838-9.149,17.838l-72.731,1.369s-4.278-31.581,6.4-31.581C829.593,761.309,877.165,764.964,877.165,764.964Z",
    transform: "translate(-648.809 -99.207)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10480",
    "data-name": "Path 10480",
    d: "M912.386,556.015a9.169,9.169,0,0,1-2.172,3.971c-10.594,11.723-52.2,8.173-56.367,10.661-.632.383-1.234,2.44-1.8,5.742h0c-1.962,11.426-3.464,37.6-4.4,58.29-.727,16.068-1.12,28.834-1.12,28.834L844.2,763.653l-26.93-4.211-16.939-2.613,8.23-65.4s.459-60.367-.957-64.032c-4.153-11.072-1.837-28.71.957-41.849a87.208,87.208,0,0,0,.68-33.1c-4.785-27.456,2.182-48.7,6.938-59.18a57.215,57.215,0,0,1,3.828-7.177s67.228-.957,79.124,6.4a16.969,16.969,0,0,1,5.311,5.972C912.548,512.176,915.831,542.244,912.386,556.015Z",
    transform: "translate(-627.328 -87.369)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10481",
    "data-name": "Path 10481",
    d: "M859.035,784.084s.459,12.345,27.437,8.689c17.427-2.364,8.527,5.742,0,11.819a33.494,33.494,0,0,1-18.833,6.2l-63.066,1.187s-4.278-31.581,6.4-31.581C811.473,780.429,859.035,784.084,859.035,784.084Z",
    transform: "translate(-613.31 -100.029)",
    fill: "#4a4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10482",
    "data-name": "Path 10482",
    d: "M994.836,394.888s-4.105.306-10.527.488c-7.12.2-17.1.239-27.456-.488-19.666-1.368-15.092-15.092-15.092-15.092l7.771-53.965s19.666-45.275,25.15-32.011-10.058,34.3-10.058,34.3-6.862,35.677,0,40.7c4.345,3.187,11.484,1.177,16.269-.727a42.576,42.576,0,0,0,4.613-2.172Z",
    transform: "translate(-843.326 -78.996)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10483",
    "data-name": "Path 10483",
    d: "M775.111,254.916,770.077,309.8s-5.943,11.436-12.8,15.092c-4.7,2.507-13.886,10.364-19.226,15.073-2.459,2.172-4.105,3.675-4.105,3.675l-13.723-21.953a26.486,26.486,0,0,1,3.168-3.6A34.988,34.988,0,0,1,740.8,308.88s1.139-3.426,3.656-9.57c1.761-4.316,12.8-28.356,12.8-28.356s4.574-19.207,3.656-28.815,14.173-27.9,16.46-25.609S781.513,245.767,775.111,254.916Z",
    transform: "translate(-416.422 -75.768)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10484",
    "data-name": "Path 10484",
    d: "M875.42,353.127s-49.39,6.862-42.988-4.115c1.761-3.015,2.794-7.388,3.369-12.135,1.512-12.517-.172-27.657-.172-27.657l37.045,6.4a49.994,49.994,0,0,0-1.522,21.934,60.646,60.646,0,0,0,4.268,15.57Z",
    transform: "translate(-619.178 -79.763)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 23.781,
    cy: 23.781,
    r: 23.781,
    transform: "translate(215.313 200.423)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10485",
    "data-name": "Path 10485",
    d: "M898.285,498.442a17.226,17.226,0,0,1-7.6,3.637c-7.321,1.368-31.1,4.115-40.251-3.206-7.254-5.8-30.9-5.857-40.375-5.627a57.217,57.217,0,0,1,3.828-7.177s67.228-.957,79.124,6.4A16.968,16.968,0,0,1,898.285,498.442Z",
    transform: "translate(-621.18 -87.368)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10486",
    "data-name": "Path 10486",
    d: "M781.369,344.537c-2.459,2.172-4.105,3.675-4.105,3.675L763.54,326.258a26.474,26.474,0,0,1,3.168-3.6C773.387,323.942,779.187,338.374,781.369,344.537Z",
    transform: "translate(-459.745 -80.341)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10487",
    "data-name": "Path 10487",
    d: "M957.854,398.238s-4.105.306-10.527.488c-10.106-12.125-4.737-24.107-3.455-27.284a42.587,42.587,0,0,0,4.613-2.172Z",
    transform: "translate(-806.344 -82.346)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10488",
    "data-name": "Path 10488",
    d: "M875.42,354.206s-49.39,6.862-42.988-4.115c1.761-3.015,2.794-7.388,3.369-12.135A41.044,41.044,0,0,1,848.433,335c8.479-2.115,17.551,1.168,22.719,3.637a60.648,60.648,0,0,0,4.268,15.57Z",
    transform: "translate(-619.178 -80.843)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10489",
    "data-name": "Path 10489",
    d: "M856.939,335.444s-19.666.957-23.322,13.723c0,0-19.207,6.4-29.274,6.862s-37.045,11.436-37.5,13.264-9.57,17.838,7.771,32.471c0,0,19.666-6.862,28.356,5.484s18.3,71.343,9.57,77.746c0,0,35.217-1.828,44.366,5.484s32.93,4.574,40.251,3.206,17.379-9.149,17.838-30.624-7.321-67.688,4.115-73.171,29.724-42.107,29.724-42.107-7.321-23.781-16.01-24.7c0,0-21.494,13.264-30.624,14.173a91.343,91.343,0,0,0-18.3,4.115S869.744,332.219,856.939,335.444Z",
    transform: "translate(-627.684 -80.359)",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10490",
    "data-name": "Path 10490",
    d: "M893.162,672s3.895-17.226,6.613-30.624c-.727,16.068-1.12,28.834-1.12,28.834l-2.325,100.12-26.93-4.211Z",
    transform: "translate(-679.457 -94.05)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10491",
    "data-name": "Path 10491",
    d: "M894.137,551s9.149,35.217,0,47.562-19.666,62.654-19.666,62.654-6.862,35.217-11.9,41.15-2.747,75.918-2.747,75.918l-59.458-3.206,26.987-107.02s8.689-38.414,9.149-45.275,2.747-66.319,2.747-66.319Z",
    transform: "translate(-611.826 -90.162)",
    fill: "#5a5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10492",
    "data-name": "Path 10492",
    d: "M861.928,291.278a34.853,34.853,0,0,0,20.1-19.523c-2.527-.957-5.177,1.378-7.866,1.2-3.254-.22-5.1-3.828-7.885-5.474-3.627-2.2-8.393-.957-12.058,1.206s-6.948,5.062-11,6.345c-3.464,1.1-7.187.88-10.823,1.091-4.613.258-14.125,1.081-17.58,4.6-1.914,1.914-1.053,3.828.689,5.436-.469,2.689.479,5.168.172,8.345a14.134,14.134,0,0,0,1.072,8.106c1.311,3.57,3.158,6.374,4.948,9.733,1.187,2.239.507,5.177,1.914,7.292a7.521,7.521,0,0,0,2.871,2.287,30.566,30.566,0,0,0,22.011,2.651c2.488-.651,5.053-1.761,6.383-3.962,2.211-3.665,0-8.335.23-12.613C855.363,301.949,860.464,297,861.928,291.278Z",
    transform: "translate(-608.432 -77.918)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10493",
    "data-name": "Path 10493",
    d: "M862.4,290.8a34.853,34.853,0,0,0,20.1-19.523c-2.526-.957-5.177,1.378-7.866,1.2-3.254-.22-5.1-3.828-7.886-5.474-3.627-2.2-8.393-.957-12.058,1.206s-6.948,5.062-11,6.345c-3.464,1.1-7.187.88-10.823,1.091-4.613.258-14.125,1.081-17.58,4.6-1.914,1.914-1.053,3.828.689,5.436-.469,2.689.478,5.168.172,8.345a14.134,14.134,0,0,0,1.072,8.106c1.311,3.57,3.158,6.374,4.948,9.733,1.187,2.239.507,5.177,1.914,7.292a7.524,7.524,0,0,0,2.871,2.287,30.567,30.567,0,0,0,22.011,2.651c2.488-.651,5.053-1.761,6.383-3.962,2.211-3.665,0-8.335.23-12.613C855.824,301.478,860.925,296.521,862.4,290.8Z",
    transform: "translate(-609.352 -77.897)",
    fill: "#4a4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10494",
    "data-name": "Path 10494",
    d: "M836.579,325.211l3.33,1.177.153-1.6S840.234,325.67,836.579,325.211Z",
    transform: "translate(-588.336 -80.433)",
    opacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhConsumerSuccess);
export default __webpack_public_path__ + "static/media/nh_consumer_success.c4e167f3b01b54b2ea568486ea559c7a.svg";
export { ForwardRef as ReactComponent };